export const tag = 'm050c080footerOpelVehicleMarket';
export const load = async () => {
    const { M050C080FooterOpelVehicleMarketComponent } = await import(
        './m050-c080-footer-opel-vehicle-market.component'
    );
    return {
        component: M050C080FooterOpelVehicleMarketComponent,
    };
};
